import { render, staticRenderFns } from "./UdefHero.vue?vue&type=template&id=620b010c&scoped=true&"
import script from "./UdefHero.vue?vue&type=script&lang=js&"
export * from "./UdefHero.vue?vue&type=script&lang=js&"
import style0 from "./UdefHero.vue?vue&type=style&index=0&id=620b010c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620b010c",
  null
  
)

export default component.exports